import { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { RenderIn, device } from '../../utils/RenderIn';
import { PageLayout } from 'dibs-elements/exports/PageLayout';

import styles from './HpRespModuleContainer.scss';

function HpCustomHeader({ title, subtitle }) {
    return (
        <div className={styles.titleWrapper}>
            <h2 className={styles.title}>{title}</h2>
            {subtitle && <div className={styles.subtitle}>{subtitle}</div>}
        </div>
    );
}

HpCustomHeader.propTypes = {
    title: PropTypes.node,
    subtitle: PropTypes.node,
};

function HpSharedModuleHeader({ title, subtitle }) {
    return title ? (
        <Fragment>
            <RenderIn deviceTypes={[device.DESKTOP, device.TABLET]}>
                <HpCustomHeader title={title} subtitle={subtitle} />
            </RenderIn>
            <RenderIn deviceTypes={[device.MOBILE]}>
                <PageLayout setOffset={false} setViewportBackground={'transparent'}>
                    <HpCustomHeader title={title} subtitle={subtitle} />
                </PageLayout>
            </RenderIn>
        </Fragment>
    ) : null;
}

HpSharedModuleHeader.propTypes = {
    title: PropTypes.node,
    subtitle: PropTypes.node,
};

class HpRespModuleContainer extends Component {
    static Header = HpSharedModuleHeader;

    render() {
        return (
            <div
                data-tn={this.props.dataTn}
                className={classnames(
                    { [styles.addTopGap]: this.props.addTopGap },
                    this.props.className
                )}
            >
                {this.props.children}
            </div>
        );
    }
}

HpRespModuleContainer.propTypes = {
    children: PropTypes.node,
    addTopGap: PropTypes.bool,
    className: PropTypes.string,
    dataTn: PropTypes.string,
};

HpRespModuleContainer.defaultProp = {
    addTopGap: false,
    className: null,
    dataTn: '',
};

export { HpRespModuleContainer };
